import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    structure: {
        type: "input",
        label: "Structure (10 Floors/Road etc)",
        isRequired: true,
        xs: 12,
        lg: 3,
        sm: 6,
        md: 3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 255
            }
        }
    },
    workScope: {
        type: "select",
        label: "Scope Of Work",
        isRequired: true,
        options: [],
        isLoading: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    }
};

export default FIELDS;